import React from 'react';
import PropTypes from 'prop-types';
import { useDeviceSize } from 'common/lib/hooks/useDeviceSize';
import {
    PROJECT_STAGE_1,
    PROJECT_STAGE_2,
    PROJECT_STAGE_3,
    PROJECT_STAGE_4,
    PROJECT_STAGE_4_TEXT,
} from 'common/lib/helpers/constants';
import { Steps, Step } from '@fabric-ds/react';
import * as S from './styles';

const ProgressBar = ({ adStageStatusOne, adStageStatusTwo, adStageStatusThree, adStageStatusFour, projectPhase }) => {
    const { isDesktop } = useDeviceSize();

    let phase;
    switch (projectPhase) {
        case PROJECT_STAGE_1:
            phase = 0;
            break;
        case PROJECT_STAGE_2:
            phase = 1;
            break;
        case PROJECT_STAGE_3:
            phase = 2;
            break;
        case PROJECT_STAGE_4:
            phase = 3;
            break;
        default:
            phase = 0;
    }

    const prosjektStatus = (
        <h2 aria-hidden="false" hidden>
            Prosjektets status
        </h2>
    );

    return (
        <div data-testid="progress-bar" className={isDesktop ? 'my-16' : 'p-16  my-16 rounded-8 bg-aqua-50'}>
            {prosjektStatus}
            <Steps horizontal={isDesktop}>
                <Step completed={phase > 0} active={phase === 0}>
                    <S.StepColor active={phase === 0}>
                        <h4>{PROJECT_STAGE_1}</h4>
                        <p>{adStageStatusOne}</p>
                    </S.StepColor>
                </Step>
                <Step completed={phase > 1} active={phase === 1}>
                    <S.StepColor active={phase === 1}>
                        <h4>{PROJECT_STAGE_2}</h4>
                        <p>{adStageStatusTwo}</p>
                    </S.StepColor>
                </Step>
                <Step completed={phase > 2} active={phase === 2}>
                    <S.StepColor active={phase === 2}>
                        <h4>{PROJECT_STAGE_3}</h4>
                        <p>{adStageStatusThree}</p>
                    </S.StepColor>
                </Step>
                <Step completed={phase > 3} active={phase === 3}>
                    <S.StepColor active={phase === 3}>
                        <h4>{PROJECT_STAGE_4_TEXT}</h4>
                        <p>{adStageStatusFour}</p>
                    </S.StepColor>
                </Step>
            </Steps>
        </div>
    );
};

ProgressBar.propTypes = {
    adStageStatusOne: PropTypes.string,
    adStageStatusTwo: PropTypes.string,
    adStageStatusThree: PropTypes.string,
    adStageStatusFour: PropTypes.string,
    projectPhase: PropTypes.string,
};

export default ProgressBar;
